import { Dialog, Button, Typography } from "@material-tailwind/react";
import { t } from "i18next";
import { PaperAirplaneIcon } from "@heroicons/react/24/outline";

interface CustomerSendToOdooDialogProps {
  open: boolean;
  customerName: string;
  isUpdate?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

const LoadingDots = () => (
  <div className="flex gap-1 items-center">
    <div className="w-1.5 h-1.5 bg-current rounded-full animate-[bounce_1s_infinite_0ms]"></div>
    <div className="w-1.5 h-1.5 bg-current rounded-full animate-[bounce_1s_infinite_200ms]"></div>
    <div className="w-1.5 h-1.5 bg-current rounded-full animate-[bounce_1s_infinite_400ms]"></div>
  </div>
);

export default function CustomerSendToOdooDialog({
  open,
  customerName,
  isUpdate = false,
  onClose,
  onConfirm,
  loading = false,
}: CustomerSendToOdooDialogProps) {

  // Empêcher la fermeture si en cours de chargement
  const handleClose = () => {
    if (!loading) {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      handler={handleClose}
      size="xs"
      dismiss={{
        enabled: !loading,
        outsidePress: !loading,
        escapeKey: !loading
      }}
    >
      <div className="p-4">
        <div className="flex items-center gap-3 mb-2">
          <div
            className="p-2 rounded-full"
            style={{ backgroundColor: "#FEF3C7" }}
          >
            <PaperAirplaneIcon className="h-5 w-5 -rotate-90" style={{ color: "#C67306" }} strokeWidth={2} />
          </div>
          <Typography variant="h5">
            {isUpdate
              ? t("client:odoo:updateTitle", { name: customerName, defaultValue: `Mettre à jour ${customerName} dans Odoo` })
              : t("client:odoo:createTitle", { name: customerName })}
          </Typography>
        </div>
        <Typography className="mb-4">
          {isUpdate
            ? t("client:odoo:confirmUpdateText", {
                defaultValue: "Cette action va mettre à jour le contact dans Odoo avec les informations actuelles d'EasyTech. Voulez-vous vraiment effectuer cette action ?"
              })
            : t("client:odoo:confirmSendText")}
        </Typography>
        <div className="flex justify-end gap-2">
          <Button
            onClick={handleClose}
            variant="outlined"
            color="blue-gray"
            size="sm"
            disabled={loading}
          >
            {t("common:cancel")}
          </Button>
          <Button
            style={{ backgroundColor: "#C67306" }}
            onClick={onConfirm}
            size="sm"
            disabled={loading}
            className="flex items-center justify-center min-w-[100px]"
          >
            {loading ? <LoadingDots /> : t("common:confirm")}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
